
import once from 'lodash/once';
import storageService from './storageService';
import storageKeys from './storageKeys';

const migrateLegacyToken = async () => {
  const [accessToken, refreshToken, legacyToken] = await Promise.all([
    storageService.getValue(storageKeys.accessToken),
    storageService.getValue(storageKeys.refreshToken),
    storageService.getValue(storageKeys.legacyToken),
  ]);

  if (accessToken || refreshToken) {
    return Promise.resolve;
  }

  if (legacyToken) {
    return Promise.all([
      storageService.setValue(storageKeys.accessToken, legacyToken),
      storageService.setValue(storageKeys.refreshToken, legacyToken),
    ]).then(() => storageService.removeValue(storageKeys.legacyToken));
  }
};

const migrateLegacyTokenOnce = once(migrateLegacyToken);

const authStorageSystem = {
  setValue: (...args) => migrateLegacyTokenOnce().then(() => storageService.setValue(...args)),
  getValue: (...args) => migrateLegacyTokenOnce().then(() => storageService.getValue(...args)),
};

const setAccessToken = async (token) => authStorageSystem.setValue(storageKeys.accessToken, token);
const getAccessToken = async () => authStorageSystem.getValue(storageKeys.accessToken);
const getAccessTokenQuick = async () => authStorageSystem.getValue(storageKeys.accessToken, true);

const setRefreshToken = async (token) => authStorageSystem.setValue(storageKeys.refreshToken, token);
const getRefreshToken = async () => authStorageSystem.getValue(storageKeys.refreshToken);


const setFcmToken = token => storageService.setValue(storageKeys.fcmToken, token);
const getFcmToken = () => storageService.getValue(storageKeys.fcmToken);

const setApnsToken = token => storageService.setValue(storageKeys.apnsToken, token);
const getApnsToken = () => storageService.getValue(storageKeys.apnsToken);

const setWorkspaceId = workspaceId => storageService.setValue(storageKeys.workspaceId, String(workspaceId));
const getWorkspaceId = () => storageService.getValue(storageKeys.workspaceId);

const setAuthTokens = (accessToken, refreshToken) => {
  return Promise.all([
    setAccessToken(accessToken),
    setRefreshToken(refreshToken),
  ]);
};

const clearSession = () => migrateLegacyTokenOnce().then(storageService.clearSession);

export default {
  setAccessToken,
  getAccessToken,
  getAccessTokenQuick,

  setRefreshToken,
  getRefreshToken,

  setFcmToken,
  getFcmToken,

  setApnsToken,
  getApnsToken,

  setWorkspaceId,
  getWorkspaceId,

  setAuthTokens,
  clearSession,
};
